import { type Course, UserAction } from "@brookbush/types";

import CourseAccreditations from "./CourseAccreditations";
import CourseAuthors from "./CourseAuthors";
import CourseBehavioralObjectives from "./CourseBehavioralObjectives";
import CourseCreditInformation from "./CourseCreditInformation";
import CourseTargetAudience from "./CourseTargetAudience";
import Dialog from "~/components/Dialog";
import { useUserAction } from "~/hooks";

const CourseInfoModal = ({ course }: { course: Course }) => {
	const { userAction, resetUserAction } = useUserAction();

	const isOpen = userAction === UserAction.COURSE_DETAILS;

	return (
		<Dialog
			isOpen={isOpen}
			onClose={resetUserAction}
			title="Course Details"
			className="max-w-2xl"
		>
			<CourseCreditInformation course={course} />

			<CourseAuthors authors={course.authors} />

			<CourseTargetAudience targetAudience={course.targetAudience} />

			<CourseAccreditations course={course} />

			<CourseBehavioralObjectives
				behavioralObjectives={course.behavioralObjectives}
			/>
		</Dialog>
	);
};

export default CourseInfoModal;
